window.URL_BASE = 'https://www.sprinta.com.br/'
window.URL_API = 'https://api.sprinta.com.br/'
window.URL_DASH_HOME = 'https://www.sprinta.com.br/dash/home/dashboard/view/'


window.strava_client_id = '2044'
window.facebook_client_id = '139285466682385'
window.gmak = "AIzaSyBXQEGjMcOWa1PS999Ej6QB6sEqy71XUtU"

window.URL_ASSETS_BASE = window.URL_BASE
window.BASE_URL_OLD = window.URL_BASE
window.URL_ASSETS_BASE_API = window.URL_BASE

window.config = {
    url_checkout:            window.URL_BASE + 'checkout/c/',
    url_event_extras_images: window.URL_BASE + 'uploads/extras/',
    url_base_old:            window.URL_BASE,
    url_attachments:         window.URL_BASE + 'anexos/file/'
}



// WEBPACK FOOTER //
// ./src/_config.js